import errorUnauthorized from './png/errorUnauthorized.png';
import closingBox from './svg/closing-box.svg';
import combinations from './svg/combinations.svg';
import customer from './svg/customer.svg';
import devicesFrames from './png/deviceframes.png';
import dump from './png/dump.png';
import entradas from './svg/entradas.svg';
import iceCream from './svg/ice-cream.svg';
import iceCream2 from './svg/icecream_5nd69k2ouf5k.svg';
import logo from './png/logo.png';
import payment from './svg/payment.svg';
import produceProduct from './svg/produce-product.svg';
import provider from './svg/provider.svg';
import purchase from './svg/purchase.svg';
import saidas from './svg/saídas.svg';
import sales from './svg/sales.svg';
import total from './svg/total.svg';

export const images = {
  errorUnauthorized,
  closingBox,
  combinations,
  customer,
  devicesFrames,
  dump,
  entradas,
  iceCream,
  iceCream2,
  logo,
  payment,
  produceProduct,
  provider,
  purchase,
  saidas,
  sales,
  total,
};
